/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type BackgroundCustomImagePickerContainer_user$ref: FragmentReference;
export type BackgroundCustomImagePickerContainer_user = {|
  +customImage: ?string,
  +$refType: BackgroundCustomImagePickerContainer_user$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "BackgroundCustomImagePickerContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "customImage",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '4270efb7d9046bccc1fcf2bf736f70cd';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Background/__generated__/BackgroundCustomImagePickerContainer_user.graphql.js